import React, { useCallback, useEffect, useState } from 'react';
import PageRouter from 'components/PageRouter';
import ApplicationLoader from 'components/ApplicationLoader';
import SideMenu from 'components/SideMenu';
import { useSessionValidation } from 'hooks/session';
import { useNotifications } from 'hooks/notification';
// import { useLocation } from 'react-router';
import { useSelector } from 'hooks/store';
import { sessionIsActiveSelector } from 'state/slices/session';
import { storageClient } from 'infra/storage';
import { STORAGE_SESSION_KEY } from 'constants/misc';
import { OrganizationContext } from 'hooks/contextOrganization';
import { useUserOrganizations } from 'hooks/userOrganizations';
import { Organization } from 'constants/interface';
import { useHistory } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  AlertContainer,
  AnimatedAlert,
  PageWrapper,
  PageContent,
  ContentWrapper,
} from './style';

const PageContainer = (): JSX.Element => {
  const isValidSession = useSessionValidation();
  const notificationsHandler = useNotifications();
  // const location = useLocation();
  const currentNotification = notificationsHandler.get();
  const notificationId = currentNotification?.id;
  const sessionIsActive = useSelector(sessionIsActiveSelector);
  const history = useHistory();

  const clearNotification = () => {
    notificationsHandler.clear();
  };

  // TODO: add test case
  useEffect(() => { // eslint-disable-line
    if (notificationId) {
      const clearTimeout = setTimeout(() => {
        notificationsHandler.clear();
      }, 10 * 1000);

      return () => {
        window.clearTimeout(clearTimeout);
      };
    }
  }, [notificationId]);

  // TODO: This if this is good or not
  // useEffect(() => {
  //   notificationsHandler.clear();
  // }, [location]);

  useEffect(() => {
    storageClient.setItem(STORAGE_SESSION_KEY, String(sessionIsActive));
  }, [sessionIsActive]);

  const userOrgs = useUserOrganizations();

  const [
    currentContextOrganization,
    setCurrentContextOrganization,
  ] = useState(userOrgs[0]);

  const onContextOrganizationChange = useCallback((org?: Organization) => {
    setCurrentContextOrganization(org);
    history.replace(ROUTES.root);
  }, [history]);

  useEffect(() => {
    if (userOrgs) {
      onContextOrganizationChange(userOrgs[0]);
    }
  }, [userOrgs, onContextOrganizationChange]);

  return (
    <>
      <AlertContainer>
        {currentNotification && (
          <AnimatedAlert
            key={currentNotification.id}
            message={currentNotification.message}
            type={currentNotification.type}
            banner
            onClose={clearNotification}
            closable
          />
        )}
      </AlertContainer>
      { isValidSession ? (
        <PageWrapper>
          <OrganizationContext.Provider
            value={{
              organization: currentContextOrganization,
              update: onContextOrganizationChange,
            }}
          >
            <SideMenu />
            <PageContent>
              <ContentWrapper>
                <PageRouter />
              </ContentWrapper>
            </PageContent>
          </OrganizationContext.Provider>
        </PageWrapper>
      ) : (
        <ApplicationLoader />
      )}
    </>
  );
};

export default PageContainer;
